// extracted by mini-css-extract-plugin
module.exports = {"btnSelectable":"ButtonFullfilled_btnSelectable__tRU5g","buttonForward":"ButtonFullfilled_buttonForward__1EBj3"};